// src/pages/Home/components/Navbar3/components/NavbarBrand.jsx

import React from "react";

export default function NavbarBrand({
  onNavigateHome,
}) {
  return (
    <button
      type="button"
      onClick={onNavigateHome}
      aria-label="Retour à l'accueil"
      className="
        mx-2 flex min-w-0
        flex-1 items-center
        justify-start gap-4
        focus-visible:outline-none
        focus-visible:ring-2
        focus-visible:ring-white/40
        md:justify-start
        md:gap-5
      "
    >
      <img
        src="/logo_NA_fondblanc.jpg"
        alt="Ligue Nouvelle-Aquitaine de Judo"
        className="
          h-[50px] w-auto
          rounded-sm
          object-contain
          md:h-[86px]
        "
      />

      <h1
        className="
          
          font-satoshi
          text-xl font-semibold
          tracking-wide
          text-white
          lg:block
          lg:text-3xl
        "
      >
        Judo Ligue Nouvelle-Aquitaine
      </h1>
    </button>
  );
}